<!--<section class="container-fluid no-padding">
    <breadcrumb></breadcrumb>
</section>-->
<!--<div class="page-heading">
    <span>{{'customer-service.Retail Customer Information' |translate}}</span>
    <a [routerLink]="['/admin/customerservice/search','recentSearch']" style="font-size:14px!important;cursor:pointer;" class="backlink backuser-btn">
        <i class="fa fa-arrow-circle-left pad-r-8"></i>&nbsp;{{'customer-service.Back to Search' |translate}}
    </a>
</div>
<div class="title-underline"></div>-->
<tabset class="nav nav-tabs admin-tab" role="tablist">
    <div class="container">
<tab *ngIf="([retailPermissions[0]] | hasAccess : customerServiceAccessLevelId)" heading="{{'customer-service.Retail Information' |translate}}" [active]="activeTab==1" customClass="product-tabs" tabTitle="FBO Profile">
    <retail-profile retailerid={{retailerid}}></retail-profile>
</tab>
<tab *ngIf="([retailPermissions[1]] | hasAccess : customerServiceAccessLevelId)" heading="{{'customer-service.Order History' |translate}}" [active]="activeTab==2" customClass="product-tabs" tabTitle="FBO Profile">
    <order-history fromPage="retail" inputid={{retailerid}}></order-history>
</tab></div>
</tabset>


// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/retail.component.html